import { render, staticRenderFns } from "./CrisisScreening.vue?vue&type=template&id=98641272&scoped=true&"
import script from "./CrisisScreening.vue?vue&type=script&lang=js&"
export * from "./CrisisScreening.vue?vue&type=script&lang=js&"
import style0 from "./CrisisScreening.vue?vue&type=style&index=0&id=98641272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98641272",
  null
  
)

export default component.exports